module.exports = __webpack_public_path__ + "img/caller_log_out.f0734b30.svg";